(() => {
  if (window.GingobaRandomRecommendations) return;
  window.GingobaRandomRecommendations = true;

  function initialise(scope) {
    const roots = [];
    if (scope.matches?.('[data-gingoba-random-products]')) roots.push(scope);
    roots.push(...scope.querySelectorAll('[data-gingoba-random-products]'));
    for (const root of roots) {
      if (root.dataset.randomReady === 'true') continue;
      const list = root.querySelector('.recommendation-products__grid');
      if (!list) continue;
      const seen = new Set();
      const items = [...list.children].filter(item => {
        const id = item.dataset.randomProductId;
        if (!id || id === root.dataset.currentProductId || seen.has(id)) return false;
        seen.add(id);
        return true;
      });
      for (let i = items.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [items[i], items[j]] = [items[j], items[i]];
      }
      const selected = items.slice(0, 4);
      for (const item of selected) item.hidden = false;
      list.replaceChildren(...selected);
      root.dataset.randomReady = 'true';
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialise(document), { once: true });
  } else {
    initialise(document);
  }
  document.addEventListener('shopify:section:load', event => initialise(event.target));
})();
